module.exports = __webpack_public_path__ + "static/media/business.c0fccb4c.svg";